import history from '@history';
import { LOANS_ROUTING_PARAMS, LoansPaths } from 'app/configs/routesConfig/loans';
import _ from 'lodash';

import { DocumentsSubtabRouteParam, LoanApplicationTabRouteParam } from 'constants/loanApplication';

import { LoanApplicationUrlSearchParams } from '../LoanApplication.constants';

import {
  ausRelatedFields,
  blurRequiredFields,
  fico,
  reportsAllowedFields,
} from './LoanHeaders.constants';

export const getIsBlurredStatus = ({ field, isProgramChangeRequired }) => {
  const isBlurRequired = blurRequiredFields.includes(field);

  return isBlurRequired && isProgramChangeRequired;
};

export const getHref = ({ field, ...params }) => {
  if (field === fico && !_.isNil(params.latestCreditReportDocumentId)) {
    const pathname = LoansPaths.applicationManagement.generatePath({
      [LOANS_ROUTING_PARAMS.applicationId]: params.applicationId,
      [LOANS_ROUTING_PARAMS.tab]: LoanApplicationTabRouteParam.DOCUMENTS,
      [LOANS_ROUTING_PARAMS.subtab]: DocumentsSubtabRouteParam.DOCUMENTS,
    });
    const searchParams = {
      [LoanApplicationUrlSearchParams.DOCUMENT_ID]: params.latestCreditReportDocumentId,
    };

    return history.createHref({ pathname, search: new URLSearchParams(searchParams).toString() });
  }
};

// ideally FE should not be responsible for header fields filtration anymore, it will be removed as a separate issue
export const checkFieldVisibility = ({
  isRunAusAllowedForLoanProgram = true,
  isApplicationLoaded,
  isReportsAllowed,
  field,
}) => {
  const isAusLoanProgramAllowedField = ausRelatedFields.includes(field);
  const isReportsAllowedField = reportsAllowedFields.includes(field);

  if (isReportsAllowedField) {
    return isReportsAllowed;
  }

  if (isAusLoanProgramAllowedField) {
    return !isApplicationLoaded || isRunAusAllowedForLoanProgram;
  }

  return true;
};

export const getIsAusLoadingStatus = ({ isAusSubmitting, field }) => {
  const isAusLoanProgramAllowedField = ausRelatedFields.includes(field);

  return isAusSubmitting && isAusLoanProgramAllowedField;
};

// A pending-changes commit can come back `isSaved: false` with an explicit `saveMessage`
// when a save gate (e.g. external loan-provider integration) blocks it. The CIC-reason and
// program-change cases carry their own flags and are handled separately, so keying on
// `saveMessage` isolates the gate-blocked case that would otherwise fall through to a false
// "saved successfully" toast (FZ-4350).
export const getBlockingSaveMessage = metadata =>
  metadata?.isSaved === false && metadata?.saveMessage ? metadata.saveMessage : null;

const CIC_REASON_NEEDED_MESSAGE =
  'These changes need a CIC reason. Use Save Pending Changes to choose one before sending disclosures.';

export const getDisclosureBlockedMessage = metadata =>
  getBlockingSaveMessage(metadata) ||
  (metadata?.cicReasonRequired ? CIC_REASON_NEEDED_MESSAGE : null);
